import { alertIcon } from '../../../../../assets/hostedassets';
import { formatRptAmount } from '../../../../../store/dashboard/relatedParties/relatedPartyTransactions_mappers';
import type { RptParty } from '../../../../../store/dashboard/relatedParties/relatedPartyTransactions.types';
import { RPT_BUCKET, RPT_VIEW_TRANSACTIONS_LABEL } from './relatedPartyTransactions_constants';
import styles from './RptTransactionsCell.module.scss';

const rptBadgeLabel = (party: RptParty): string =>
    party.transactionCount === 1 && party.singleAmount !== null && party.bucket !== RPT_BUCKET.INDIVIDUAL
        ? formatRptAmount(party.singleAmount)
        : RPT_VIEW_TRANSACTIONS_LABEL;

function RptTransactionsCell({ party, onOpen }: { party?: RptParty; onOpen: (party: RptParty) => void }) {
    if (!party) return null;
    return (
        <button
            type="button"
            className={styles.Badge}
            onClick={(event) => {
                event.stopPropagation();
                onOpen(party);
            }}
        >
            <img src={alertIcon} alt="" className={styles.Icon} />
            <span className={styles.Label}>{rptBadgeLabel(party)}</span>
        </button>
    );
}

export default RptTransactionsCell;
